import React from 'react';
import './FreePremium.css';
import { Link } from 'react-router-dom';

type Props = {
  isNova?: boolean;
  tier?: string;
};

const FreePremium: React.FC<Props> = ({isNova = true, tier = 'free'}) => {
  return (
    <>
      <h3 className="dashboard-profile-title"><span className="text-gradient text-gradient--premium">ELSA Free・ELSA Pro・ELSA Premium</span>の機能比較</h3>
      <div className="card-package">
        <div className="card-package__panel">
          <div className="card-package-header">
              <div className="plan-compare">
                <table>
                  <thead>
                    <tr>
                      <th scope="col">プラン比較</th>
                      <th scope="col"><span className="plan-compare__brand">ELSA</span><span className="plan-compare__badge plan-compare__badge--free">Free</span></th>
                      <th scope="col"><span className="plan-compare__brand text-gradient text-gradient--pro">ELSA</span><span className="plan-compare__badge plan-compare__badge--pro">Pro</span></th>
                      <th scope="col" className="plan-compare__premium"><span className="plan-compare__brand text-gradient text-gradient--premium">ELSA</span><span className="plan-compare__badge plan-compare__badge--premium">Premium</span></th>
                    </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th scope="row">学習プランの作成</th>
                    <td className="plan-compare__limited">制限付き</td>
                    <td>✅</td>
                    <td className="plan-compare__premium">✅</td>
                  </tr>
                  <tr>
                    <th scope="row">毎日のレッスン</th>
                    <td className="plan-compare__limited">制限付き</td>
                    <td>✅</td>
                    <td className="plan-compare__premium">✅</td>
                  </tr>
                  <tr>
                    <th scope="row">AIコーチ</th>
                    <td className="plan-compare__limited">制限付き</td>
                    <td className="plan-compare__limited">制限付き</td>
                    <td className="plan-compare__premium">✅</td>
                  </tr>
                  <tr>
                    <th scope="row">試験対策コース（IELTS・HarperCollins）</th>
                    <td>❌</td>
                    <td>❌</td>
                    <td className="plan-compare__premium">✅</td>
                  </tr>
                  <tr>
                    <th scope="row">ビジネスコース（Oxford）</th>
                    <td>❌</td>
                    <td>❌</td>
                    <td className="plan-compare__premium">✅</td>
                  </tr>
                  <tr>
                    <th scope="row">実践ロールプレイ</th>
                    <td className="plan-compare__limited">制限付き</td>
                    <td className="plan-compare__limited">制限付き</td>
                    <td className="plan-compare__premium">✅</td>
                  </tr>
                  <tr>
                    <th scope="row">スピーチアナライザー</th>
                    <td>❌</td>
                    <td className="plan-compare__limited">制限付き</td>
                    <td className="plan-compare__premium">✅</td>
                  </tr>
                  <tr>
                    <th scope="row">広告なし</th>
                    <td>❌</td>
                    <td>✅</td>
                    <td className="plan-compare__premium">✅</td>
                  </tr>
                  </tbody>
                </table>
              </div>
          </div>

          <div className="card-package-body">
            <h3 className="card-package-body__title">最新のELSAを体験しよう</h3>
            <p>AIがあなたの英語学習をサポート。</p>
            <Link to="/elsa-premium" className="btn-primary">今すぐ始める</Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default FreePremium;
